import Api from '@api/experienceShop'
import { observable } from 'mobx'

class Store {
  @observable brokerageInfo = {}

  getBrokerageInfo = async () => {
    const { data } = await Api.brokerageInfo()
    this.brokerageInfo = data
  }
}

export default Store
